export const not = <T>(a: T[], b: T[]): T[] => {
  return a.filter((value) => b.indexOf(value) === -1);
};

export const intersection = <T>(a: T[], b: T[]): T[] => {
  return a.filter((value) => b.indexOf(value) !== -1);
};

export const union = <T>(a: T[], b: T[]): T[] => {
  return [...a, ...not(b, a)];
};
